import { Tariff } from '@coc-kfz-digital/oma-rest-api-client';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';


@Component({
  selector: 'app-tariff-tile',
  templateUrl: './tariff-tile.component.html',
  styleUrls: ['./tariff-tile.component.scss'],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: '0', overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: '1' }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: '1', overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0', opacity: '0' }))
      ])
    ])
  ]
})
export class TariffTileComponent {
  constructor() { }

  @Input() tariff: Tariff = {};

  @Input() selectTariffLabel: string;

  @Input() submitted = false;

  @Output()
  selected: EventEmitter<Tariff> = new EventEmitter<Tariff>();

  // Benefits collapsed by default
  benefitsExpanded = false;

  toggleBenefits() {
    this.benefitsExpanded = !this.benefitsExpanded;
  }
}
